import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { WhyPage } from "@/features/mentions/WhyPage";
import { useAppShell } from "@/shell/app-shell-context";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { canOperate, hasRoleAtLeast } from "@/shared/utils/roles";

/** A página das justificativas da classificação da empresa (2026-10-20). */
export function WhyRoute() {
  const { token, openMention, mentionChange, profile } = useAppShell();
  const [searchParams, setSearchParams] = useSearchParams();
  const company = useRequireCompany();

  // O filtro de upload mora na URL (`?upload=7&upload=4`), não na loja
  // compartilhada de filtros — é o único que a tela de menções recebe pela
  // rota —, então esta página o lê igual (2026-10-21), `getAll` porque o
  // parâmetro repete. Memoizado pelo TEXTO, como em `MentionsRoute`: a lista
  // é dependência dos efeitos da página (recarga, página 1, seleção), e esta
  // rota re-renderiza a cada mudança do contexto da casca (contador da
  // sidebar, `mentionChange`); um array novo por render recarregaria em laço.
  const uploadKey = searchParams.getAll("upload").join(",");
  const uploadFilter = useMemo(
    () =>
      uploadKey
        .split(",")
        .map(Number)
        .filter(value => Number.isInteger(value) && value > 0),
    [uploadKey]
  );

  // O link do sino (`?consultoria=<id>`): a página abre o painel e a rota
  // tira o parâmetro, pra um F5 não reabrir (como `?reprocessamento=`).
  const reviewLink = Number(searchParams.get("consultoria")) || null;
  const consumeReviewLink = () => {
    const next = new URLSearchParams(searchParams);
    next.delete("consultoria");
    setSearchParams(next, { replace: true });
  };

  if (!company) return null;

  return (
    <WhyPage
      token={token}
      companyId={company.id}
      openMention={openMention}
      mentionChange={mentionChange}
      uploadFilter={uploadFilter}
      reviewLink={reviewLink}
      onConsumeReviewLink={consumeReviewLink}
      canReview={hasRoleAtLeast(profile, "specialist")}
      canGenerateSummary={canOperate(profile)}
    />
  );
}
